import { useEffect, useRef, useState } from "react";
import { TINY_MCE_KEY } from "../../utils/constants";
import { Editor } from "@tinymce/tinymce-react";
import axios from "axios";3
import PAlert from '../../common/PAlert';

export default function TermsForm() {
    const editorRef = useRef(null);
    const [termsVal, setTermsVal] = useState(null);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [showAlert, setShowAlert] = useState(false);

    useEffect(() => {
        getCurrentTermsAndConditions();
    }, []);

    useEffect(() => {
        const onReload = function () {
            const _body = editorRef.current.getContent();
            if(termsVal !== _body) {
                return "The changes you made are not yet saved.";
            }

            return null;
        };

        window.onbeforeunload = onReload;

        return () => {
            window.onbeforeunload = null;
        };
    }, [termsVal]);

    const getCurrentTermsAndConditions = () => {
        // todo: get current terms and condition request
        axios
            .get("/api/terms-and-conditions")
            .then((res) => {
                const _terms = res.data;
                setTermsVal(_terms.content);
            })
            .catch((err) => {
                console.log(err.response);
            });
    };

    const saveTermsAndConditions = () => {
        // todo: save request
        const _body = editorRef.current.getContent();
        if (_body === "") {
            setBtnDisabled(true);
            return;
        }

        axios
            .post("/api/terms-and-conditions", {
                slug: '/terms',
                content: _body,
            })
            .then((res) => {
                console.log(res);
                setShowAlert(true);
                setTermsVal(_body);
            })
            .catch((err) => {
                console.log(err.response);
            });
    };

    const onEditorChange = () => {
        const _body = editorRef.current.getContent();
        if (_body !== termsVal && _body !== "") {
            setBtnDisabled(false);
        }
    };

    return (
        <>
            <div>
                <h3>Terms & Conditions</h3>
                <div className="bg-white" style={{ minHeight: document.body.clientHeight - 200 }}>
                    {termsVal !== null ? (
                        <>
                            <Editor
                                onInit={(evt, editor) =>
                                    (editorRef.current = editor)
                                }
                                apiKey={TINY_MCE_KEY}
                                initialValue={termsVal}
                                onChange={onEditorChange}
                                init={{
                                    theme_advanced_resizing: true,
                                    selector:
                                        "textarea#full-featured-non-premium",
                                    plugins: [
                                        "print preview paste importcss searchreplace autolink",
                                        "save directionality code visualblocks visualchars",
                                        "fullscreen image link media template codesample table charmap",
                                        "hr pagebreak nonbreaking anchor toc insertdatetime advlist",
                                        "lists wordcount imagetools textpattern noneditable help quickbars emoticons",
                                    ],
                                    toolbar: [
                                        "image media | insertfile undo redo | bold italic underline strikethrough | styleselect | fontselect fontsizeselect formatselect",
                                        "alignleft aligncenter alignright alignjustify | outdent indent | bullist numlist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | ",
                                        "template link anchor codesample | ltr rtl",
                                    ],
                                    height: document.body.clientHeight - 200,
                                }}
                            />
                        </>
                    ) : null}
                </div>
                <div className="mt-2 d-flex flex-row justify-content-end">
                    <button
                        className="btn btn-primary"
                        onClick={saveTermsAndConditions}
                        disabled={btnDisabled}
                    >
                        SAVE CHANGES
                    </button>
                </div>
            </div>

            <PAlert show={showAlert} 
                    setShow={setShowAlert} 
                    body={`<h3>Success!</h3>`}
                    bodyStyle={{
                        paddingTop: 16,
                        textAlign: 'center'
                    }}
                    footerStyle={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    size={"sm"} />
        </>
    );
}
